<template>

    <div class="popup active">
        <div class="notice_popup human">
            <div class="close">
                <img src="/images/close.png" alt="닫기" @click="$emit('close', false)"/>
            </div>
            <div class="member pt-6">
				클라이언트 로그인 후 <br />
				전체 내용을 확인하실 수 있습니다.
			</div>

            <div class="select-btn">
                <!-- <div class="btn" @click="$emit('close', false)">취소</div> -->
                <div class="btn blue pa-4" style="width:300px; height:50px;" @click="$emit('close', true)">로그인/회원가입</div>
            </div>
        </div>
    </div>

</template>

<script>

export default {

	components : {		
	},

	props: ['param'],

	data() {
		return {		
		};
	},
	beforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');		
	},
	mounted() {
		// console.log('mounted');
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {		
	},
};
</script>
